import { SxProps, Theme } from '@mui/material';

export const locationHolidayHoursStyles = {
  accordion: {
    boxShadow: 'none',
    '&:before': { display: 'none' },
    '& .MuiAccordionSummary-root': {
      padding: 0,
      minHeight: 'auto',
      '&.Mui-expanded': {
        minHeight: 'auto',
      },
    },
    '& .MuiAccordionSummary-content': {
      marginY: 0,
      '&.Mui-expanded': {
        marginY: '16px',
      },
    },
    '& .MuiAccordionDetails-root': {
      padding: '16px 0 0 0',
      maxWidth: '500px',
    },
  } as SxProps<Theme>,

  titleTypography: {
    margin: 0,
  } as SxProps<Theme>,

  holidayRow: {
    display: 'grid',
    gridTemplateColumns: '1.2fr 0.8fr 1fr',
    gap: 1,
  } as SxProps<Theme>,
};
